/**
 * AI Routes
 * Re-exports the AI Management routes from pages/app/AiManagement
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import AiLandingPage from '../pages/app/AiManagement/index';
import WorkflowWizardPage from '../pages/app/AiManagement/Workflow/index';
import SessionsPage from '../pages/app/AiManagement/Sessions/index';
import DocumentLibraryPage from '../pages/app/AiManagement/Documents/index';
import DocumentQAPage from '../pages/app/AiManagement/Documents/DocumentQA';

export default function AiRoutes() {
  return (
    <MainLayout domainKey="ai">
      <Routes>
        <Route path="/" element={<AiLandingPage />} />
        <Route path="workflow" element={<WorkflowWizardPage />} />
        <Route path="sessions" element={<SessionsPage />} />
        <Route path="documents" element={<DocumentLibraryPage />} />
        <Route path="documents/qa" element={<DocumentQAPage />} />
        <Route path="*" element={<Navigate to="/app/ai" replace />} />
      </Routes>
    </MainLayout>
  );
}
